import { USER_LOGGED_IN, USER_LOGGED_OUT, loadProcessToken } from "../actions/index";
import axios from "axios";

let token =localStorage.getItem('token') || null;
if (token) {
        token = JSON.parse(token);
        let time_expired = Date.now() - token["timestamp"];
        let expiry_window =(token['ExpiresIn']) * 1000;
        if ( time_expired > expiry_window){
            token = null;
        }
}


export default function (state = token, action) {
    switch (action.type) {
        case USER_LOGGED_IN:
            console.log("RECEIVED USER LOGGED IN EVENT");
            console.log("UPDATING TOKEN");
            axios.defaults.headers.common['Authorization'] = "Bearer " + action.payload["IdToken"];
            let tokens = action.payload
            tokens["timestamp"]=Date.now()
            tokens["refresh_request"] = false;
            localStorage.setItem('token', JSON.stringify(tokens));
            return tokens;
        case USER_LOGGED_OUT:
            localStorage.removeItem('token');
            return null;
        default:
            return state;
    }
}
